import { SelectionItem } from './SelectionItem/SelectionItem';
import css from './SelectionItemsList.module.css';
import { ItemTypeEntity } from '@entities/ItemType/Types';
import { ItemEntity } from '@entities/Item/Types';

interface Props {
    itemType: ItemTypeEntity;
    items: ItemEntity[];
    isFillDisabled: boolean;
}

export const SelectionItemsList: React.FC<Props> = ({
    items,
    isFillDisabled,
    itemType,
}) => {
    return (
        <ul className={css.list}>
            {items.map(item => (
                <SelectionItem
                    key={item.uuid}
                    item={item}
                    isFillDisabled={isFillDisabled}
                    itemType={itemType}
                />
            ))}
        </ul>
    );
};
